export default __webpack_public_path__ + "static/media/delete_light.cdab9e25.svg";